module.exports = __webpack_public_path__ + "img/support4.004bf238.webp";